import { EnumValue } from "../../Common/Util";

export class StockById {
    constructor({ itemIds = [] }) {
        this.itemIds = itemIds;
    }
}

class AssignmentEntity {
    constructor({ assignId, assignmentType }) {
        this.assignId = assignId;
        this.assignmentType = assignmentType;
    }
}

export const Assigments = {
    General: 'General',
    Protocol: 'Protocol',
    ProtocolLaboratoryKit: 'ProtocolLaboratoryKit'
}

export const GeneralAssigment = new AssignmentEntity({ assignId: null, assignmentType: 'General' })
export const ProtocolAssigment = (protocolId) => {
    if (protocolId == undefined || protocolId == null || protocolId < 1)
        throw new Error('Invalid protocol ID');

    return new AssignmentEntity({ assignId: protocolId.toString(), assignmentType: 'Protocol' })
}
export const ProtocolLaboratoryKitAssignment = (protocolId) => {
    if (protocolId == undefined || protocolId == null || protocolId < 1)
        throw new Error('Invalid protocol ID');

    return new AssignmentEntity({ assignId: protocolId.toString(), assignmentType: 'ProtocolLaboratoryKit' })
}
export class Release {
    constructor({ id, lotNumber, expirationDate, quantity, }) {
        this.id = id;
        this.lotNumber = lotNumber;
        this.expirationDate = expirationDate;
        this.quantity = quantity;
    }
}

export class InventoryItem {
    constructor({ id, presentation, externalId, releases = [] }) {
        this.id = id;
        this.releases = releases;
        this.presentation = presentation;
        this.externalId = externalId;
    }
    #existingReleases = new Map()
    #newReleases = new Map()

    AddExistingRelease(releaseId, quantity) {
        if (this.#existingReleases.has(releaseId)) {
            const currentValue = this.#existingReleases.get(releaseId);
            this.#existingReleases.set(releaseId, currentValue + quantity);
        } else {
            this.#existingReleases.set(releaseId, quantity)
        }
    }

    AddNewRelease({ lotNumber, expirationDate, quantity }) {
        if (this.#newReleases.has(lotNumber)) {
            const currentRelease = this.#existingReleases.get(lotNumber);
            currentRelease.quantity += quantity;
            this.#newReleases.set(lotNumber, currentRelease);
        } else {
            this.#newReleases.set(lotNumber, new Release({ expirationDate, lotNumber, quantity }))
        }
    }

    GetReleases() {
        return new Array()
            .concat(this.#existingReleases.entries().map(([key, value]) => new Release({ id: key, quantity: value })))
            .concat(this.#newReleases.values)
    }
}

export class InventoryItemLight {
    constructor({ id, origin, type, externalId, inventoryItemId, presentation }) {
        this.inventoryItemId = inventoryItemId ?? id;
        this.id = id ?? inventoryItemId;
        this.origin = origin;
        this.type = type;
        this.externalId = externalId;
        this.presentation = presentation;
    }
}

export class Stock {
    constructor({ items = [], assignment }) {
        this.items = items;
        this.assignment = assignment;
    }
}

export class ItemStock {
    constructor({ itemId, stock }) {
        this.itemId = itemId;
        this.stock = stock
    }
}

export class ReleaseStockResult {
    constructor({ id, itemId, releaseId, lotNumber, expirationDate, quantity }) {
        this.id = id;
        this.itemId = itemId;
        this.releaseId = releaseId;
        this.lotNumber = lotNumber;
        this.expirationDate = expirationDate;
        this.quantity = quantity;
    }
}

export const ReleaseStockState = {
    Deleted: new EnumValue(-1, "Deleted"),
    Available: new EnumValue(1, "Available"),
    Reserved: new EnumValue(2, "Reserved"),
    Dispensed: new EnumValue(3, "Dispensed"),
    WaitingForReturn: new EnumValue(4, "WaitingForReturn"),
    WaitingForDestruction: new EnumValue(5, "WaitingForDestruction"),
    Destroyed: new EnumValue(6, "Destroyed"),
    Missed: new EnumValue(7, "Missed"),
    Damaged: new EnumValue(8, "Damaged"),

    From: (name) => {
        switch (name?.toLowerCase()) {
            case "available": return ReleaseStockState.Available;
            case "reserver": return ReleaseStockState.Reserved;
            case "dispensed": return ReleaseStockState.Dispensed;
            case "waitingforReturn": return ReleaseStockState.WaitingForReturn;
            case "waitingforDestruction": return ReleaseStockState.WaitingForDestruction;
            case "destroyed": return ReleaseStockState.Destroyed;
            case "missed": return ReleaseStockState.Missed;
            case "damaged": return ReleaseStockState.Damaged;
            default: return EnumValue.Unknown();
        }
    },

    ToArray: () => [
        ReleaseStockState.Available,
        ReleaseStockState.Reserved,
        ReleaseStockState.Dispensed,
        ReleaseStockState.WaitingForReturn,
        ReleaseStockState.WaitingForDestruction,
        ReleaseStockState.Destroyed,
        ReleaseStockState.Missed,
        ReleaseStockState.Damaged
    ]
};


export const AssignmentType = {
    General: new EnumValue(1, "General"),
    Protocol: new EnumValue(2, "Protocol"),
    ProtocolLaboratoryKit: new EnumValue(2, "ProtocolLaboratoryKit"),
    From: (name) => {
        switch (name?.toLowerCase()) {
            case "general": return AssignmentType.General;
            case "protocol": return AssignmentType.Protocol;
            case "protocollaboratorykit": return AssignmentType.ProtocolLaboratoryKit;
            default: return EnumValue.Unknown();
        }
    }, ToArray: () => [
        AssignmentType.General,
        AssignmentType.Protocol,
        AssignmentType.ProtocolLaboratoryKit,
    ]
}

export const Assignment = {
    GeneralAssigment: () => new AssignmentEntity({ assignId: null, assignmentType: AssignmentType.General.Name }),
    ProtocolAssigment: (protocolId) => {
        if (protocolId == undefined || protocolId == null || protocolId < 1)
            throw new Error('Invalid protocol ID');

        return new AssignmentEntity({ assignId: protocolId, assignmentType: AssignmentType.Protocol.Name })
    }
}

export const ExpirationGap = {
    // cantidad de meses
    Warning: 6,
    Critical: 2,
}
export function IsExpirationLessThan(release, monthGap) {
    return new Date(release.expirationDate) <= new Date(new Date().setMonth(new Date().getMonth() + monthGap))
}